import { Button, Card, Col, notification, Row } from 'antd';
import React from 'react';
import { CopyOutlined } from '@ant-design/icons';
import { formatarData } from '../../helpers/utils';
import { Status, BlocoJson, TagResponsiva } from './styles';

function DescriberPayload(props) {
  const {
    statusCode,
    mensagemDeErro,
    dataHora,
    payload,
    response,
    request,
    exibeMensagemErro = true,
  } = props;

  const exibeJson = obj => {
    let treatedObj = JSON.stringify(obj, null, 4);
    treatedObj = treatedObj.substring(1);
    treatedObj = treatedObj.slice(0, -1);
    return treatedObj;
  };

  const codigoDesc = {
    400: {
      color: 'red',
      titulo: 'Inválido',
    },
    500: {
      color: 'red',
      titulo: 'Erro na fila',
    },
  };

  const copyFunction = text => {
    navigator.clipboard.writeText(JSON.stringify(text));
    document.execCommand('copy');

    return notification.success({
      description: 'Copiado com sucesso',
    });
  };

  function CopyButton(payloadObj) {
  return <Button onClick={() => copyFunction(payloadObj)}>
      Copiar
{' '}
<CopyOutlined />
         </Button>;
}

  return (
    <div>
      <Status>
        <Row gutter={[16, 0]}>
          <Col xs={24} sm={24} md={24} lg={24} xl={24}>
            <strong> Status: </strong>
            <TagResponsiva
              color={
                statusCode && !!codigoDesc[statusCode]?.color
                  ? codigoDesc[statusCode]?.color
                  : 'red'
              }
              key="codigoHttp"
            >
              {statusCode && !!codigoDesc[statusCode]?.titulo
                ? codigoDesc[statusCode]?.titulo
                : 'Erro na fila'}
              {mensagemDeErro && exibeMensagemErro
                ? ` - ${mensagemDeErro}`
                : ''}
            </TagResponsiva>
          </Col>
        </Row>
        <Row gutter={[16, 0]}>
          <Col xs={24} sm={24} md={24} lg={24} xl={24}>
            <strong>Atualizado </strong>
:
{formatarData(dataHora)}
          </Col>
          <Col xs={24} sm={24} md={24} lg={24} xl={24}>
            <strong>Url do request: </strong>
            {request?.url}
          </Col>
        </Row>
      </Status>
      <Row gutter={[16, 0]}>
        <Col xs={24} sm={24} md={12} lg={12} xl={12}>
          <Card
            title="Payload Envio"
            extra={<CopyButton payloadObj={payload} />}
          >
            <Row gutter={[16, 0]}>
              <Col xs={24} sm={24} md={24} lg={24} xl={24}>
                <BlocoJson>
                  {'{'}
                  {exibeJson(payload)}
                  {'}'}
                </BlocoJson>
              </Col>
            </Row>
          </Card>
        </Col>
        <Col xs={24} sm={24} md={12} lg={12} xl={12}>
          <Card
            title="Payload Resposta"
            extra={<CopyButton payloadObj={response} />}
          >
            <Row gutter={[16, 0]}>
              <Col xs={24} sm={24} md={24} lg={24} xl={24}>
                <BlocoJson>
                  {'{'}
                  {exibeJson(response)}
                  {'}'}
                </BlocoJson>
              </Col>
            </Row>
          </Card>
        </Col>
      </Row>
    </div>
  );
}

export default DescriberPayload;
